import { RadioButton } from 'components/RadioButton/RadioButton';
import { ChangeEvent, useEffect, useState } from 'react';

export type RadioButtonGroupArrangement = 'inline' | 'row' | 'column';

export type RadioButtonGroupProps = {
  items: {
    label: string;
    value: string;
  }[];
  groupName: string;
  arrangement?: RadioButtonGroupArrangement;
  hasBorder?: boolean;
  doOptionsFillSpace?: boolean;
  value?: string;
  onChange: (newOpt: string) => void;
};

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  items,
  groupName,
  arrangement = 'row',
  hasBorder,
  doOptionsFillSpace,
  value,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(
    value || null,
  );

  useEffect(() => {
    setSelectedValue(value || null);
  }, [value]);

  const arrangementClasses = (() => {
    switch (arrangement) {
      case 'inline':
        return 'flex-wrap space-x-3 space-y-3';
      case 'row':
        return 'flex flex-row space-x-3';
      case 'column':
        return 'flex flex-col space-y-3';
    }
  })();
  const onRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(e.target.value);
    onChange(e.target.value);
  };
  return (
    <fieldset className={arrangementClasses}>
      {items.map(({ label, value }) => (
        <RadioButton
          key={`radio-buttons-${groupName}-${value}`}
          label={label}
          value={value}
          hasBorder={hasBorder}
          groupName={groupName}
          isFullWidth={doOptionsFillSpace}
          onChange={onRadioChange}
          checked={value === selectedValue}
        />
      ))}
    </fieldset>
  );
};
